import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React from 'react';
import { DateFilterDropdown } from '../../../../components/DateFilterDropdown';
import {
    DATE_FILTER_OPTIONS,
    DATE_FILTER_VALUES,
    DATE_URL_KEYS,
} from '../../../../constants/dates';
import { useRouteContext } from '../../context';

interface CategoryBrowseDateFilter {
    locale: string;
}

export const CategoryBrowseDateFilter: React.FunctionComponent<
    CategoryBrowseDateFilter
> = (props) => {
    const { parsedValues, location, history } = useRouteContext();

    const params = new URLSearchParams(location?.search);
    const date = params.get('date') || '';

    const startDate = parsedValues?.customDate?.from || '';
    const endDate = parsedValues?.customDate?.to || '';

    const handleTextItemSelect = (value: string, callback?: () => void) => {
        if (value === DATE_FILTER_VALUES.CUSTOM_DATE) {
            return;
        }

        params.delete('start_date');
        params.delete('end_date');
        params.set('date', value);

        trackAnalyticsEvent({
            category: 'category-page',
            action: 'DateFilter',
            label: value,
        });

        updateRoute(params);
        callback?.();
    };

    const handleCustomDateSelect = (
        {
            startDate,
            endDate,
        }: {
            startDate: string;
            endDate: string;
        },
        callback: () => void,
    ) => {
        if (startDate && endDate) {
            params.delete(DATE_URL_KEYS.DATE);

            params.set(DATE_URL_KEYS.START_DATE, startDate);
            params.set(DATE_URL_KEYS.END_DATE, endDate);

            trackAnalyticsEvent({
                category: 'category-page',
                action: 'DateFilter',
                label: `${DATE_URL_KEYS.START_DATE}: ${startDate} - ${DATE_URL_KEYS.END_DATE}: ${endDate}`,
            });

            updateRoute(params);
            callback?.();
        }
    };

    const updateRoute = (params: URLSearchParams) => {
        const pathname = location?.pathname || '/b/online/music/';
        const path = `${pathname}?${params.toString()}`;

        history?.push(path);
    };

    const resetDateParams = () => {
        params.delete(DATE_URL_KEYS.DATE);
        params.delete(DATE_URL_KEYS.START_DATE);
        params.delete(DATE_URL_KEYS.END_DATE);
        updateRoute(params);
    };

    return (
        <DateFilterDropdown
            resetDateParams={resetDateParams}
            onCustomDateSelect={handleCustomDateSelect}
            onTextItemSelect={handleTextItemSelect}
            date={date}
            startDate={startDate}
            endDate={endDate}
            dropdownItems={DATE_FILTER_OPTIONS}
            locale={props.locale}
        />
    );
};
